import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ContentHeader from '../ContentHeader';
import CardContainer from '../CardContainer';
import Card from '../Card';
import RewardCard from '../Cards/RewardCard';
import api from '../../api'
import styles from './styles.module.scss';
import AddChoicesRewards from '../PopUps/AddChoices&Rewards';
import ListChoicesTriggers from '../PopUps/ListChoicesTriggers';
import AddRewardPopUp from '../PopUps/AddRewardPopUp';
import EditChoicesRewards from '../PopUps/EditChoices&Rewards';
const Badges = props => {

    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');

    const send = async () => {
        console.log('send');

        if (!title.length) {
            alert('You must enter a title');
            return;
        }

        if (!message.length) {
            alert('You must enter a message');
            return;
        }

        try {
            await api.notifications.broadcast(title, message);
            setTitle('');
            setMessage('');
            alert('This notification has been queued. It may take a while to send to every user of the app as we queue them to balance server load.');
        } catch (e) {
            alert('Could not send notification.');
        }
    };

    return (
        <div className={styles.Badges}>
            <div className={styles.HeaderButtonWrapper}>
                <ContentHeader>Notifications</ContentHeader>
            </div>

            <div class="w-full max-w-md">
                <div class="bg-white p-6 sm:p-8 rounded-xl shadow-2xl">

                    <div class="space-y-6">
                        <div>
                            <label for="input1" class="block text-sm font-medium text-gray-700 mb-2">
                                Title
                            </label>
                            <input
                                type="text"
                                placeholder="Go For Gold This Weekend!"
                                className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 transition duration-150 ease-in-out"
                                required
                                value={title}
                                onChange={e => setTitle(e.target.value)}
                            />
                        </div>

                        <div>
                            <label for="input2" class="block text-sm font-medium text-gray-700 mb-2">
                                Message
                            </label>
                            <input
                                type="text"
                                placeholder="Remember to get some steps in and get to the top of your group!"
                                className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500 transition duration-150 ease-in-out"
                                required
                                value={message}
                                onChange={e => setMessage(e.target.value)}
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        class="w-full mt-8 
                       bg-indigo-600 text-white 
                       font-semibold py-3 px-4 rounded-lg 
                       shadow-lg hover:bg-indigo-700 
                       focus:outline-none focus:ring-4 focus:ring-indigo-500 focus:ring-opacity-50 
                       transition duration-200 ease-in-out transform hover:scale-[1.01]"
                        onClick={send}
                    >
                        Send Notification
                    </button>

                </div>
            </div>
        </div>
    );
};

Badges.propTypes = {};

export default Badges;